import { getSuggestedJiraLabels } from '@atlassian/search-client';

import type {
	InitialOptionsFetcher,
	LookupFetcher,
	QueryParamsFetcher,
	SelectFilterOption,
} from '../../../../../../common/constants/filters/select-filter/types';

export const jiraInitialOptionsFetcher: InitialOptionsFetcher = async (config) => {
	if (!window) {
		return []; // SSR Safety
	}
	const hostname = window.location.origin;
	const response = await getSuggestedJiraLabels({ absoluteUrl: hostname });

	return response.suggestions.map(
		(suggestion) =>
			({
				trackingKey: suggestion.label,
				value: suggestion.label,
				queryParamValue: suggestion.label,
				isDefault: false,
				label: suggestion.label,
				isSelected: false,
				isSuggested: true,
				product: config.product,
			}) satisfies SelectFilterOption,
	);
};

export const jiraLookupFetcher: LookupFetcher = async (query, config) => {
	if (!window) {
		return []; // SSR Safety
	}
	const hostname = window.location.origin;
	const response = await getSuggestedJiraLabels({ query, absoluteUrl: hostname });

	return response.suggestions.map(
		(suggestion) =>
			({
				trackingKey: suggestion.label,
				value: suggestion.label,
				queryParamValue: suggestion.label,
				isDefault: false,
				label: suggestion.label,
				isSelected: false,
				isSuggested: false,
				product: config.product,
			}) satisfies SelectFilterOption,
	);
};

export const jiraQueryParamFetcher: QueryParamsFetcher = async (queryParams, config) => {
	const options = queryParams.map((queryParam) => ({
		trackingKey: queryParam,
		value: queryParam,
		queryParamValue: queryParam,
		isDefault: false,
		label: queryParam,
		isSelected: true,
		isSuggested: false,
		product: config.product,
	}));

	return options;
};
